// Module
var code = `<div class="modal-dialog" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<button type="button" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
			<h4 class="modal-title" data-bind="text: title"></h4>
		</div>
		<div class="modal-body">
			<div class="container" data-bind="html: body"></div>
		</div>
		<div class="modal-footer">
			<!-- ko if: showCancel() -->
			<button type="button" data-bind="click: function(){ clickedClose(); }, html: cancelHtml, css: cancelCss">
				Cancel
			</button>
			<!-- /ko -->
			<!-- ko if: showNo() -->
			<button type="button" data-bind="click: function () { clickedNo(); }, html: noHtml, css: noCss">No</button>
			<!-- /ko -->
			<!-- ko if: showYes() -->
			<button type="button" data-bind="click: function () { clickedYes(); }, html: yesHtml, css: yesCss">
				Yes
			</button>
			<!-- /ko -->
		</div>
	</div>
</div>
`;
// Exports
export default code;